import React, { useContext } from 'react'
import './styles/Navbar.css'
import { menuLinks } from "app/data/menuLinks"
import { StoreContext } from "app/store/store"
import SiteGrid from "../ui/SiteGrid"
import { Link, NavLink, useLocation } from "react-router-dom"
import AppButton from "../ui/AppButton"
import logo from 'app/assets/images/web-logo.png'
import blueLogo from 'app/assets/images/web-logo-blue.png'
import { usePageScroll, useWindowHeight } from "app/hooks/generalHooks"
import { useEffect } from "react"
import { useState } from "react"

export default function Navbar() {

  const { setShowMobileSidebar } = useContext(StoreContext)
  const [showSidebar, setShowSidebar] = useState(false)
  const location = useLocation()
  const isHomepage = location.pathname === '/'
  const windowHeight = useWindowHeight()
  const scrollAmount = (isHomepage && windowHeight > 720) ? 140 : 50
  const pageScrolled = usePageScroll(scrollAmount)
  const isShort = windowHeight < 600

  const menuLinksRender = menuLinks
  ?.map((link, index) => {
    return <div
      className="menu-item"
      key={index}
    >
      {
        link.url ?
        <NavLink to={link.url}>
          {link.name}
          <hr />
        </NavLink> :
        <a>
          {link.name}
          <hr />
        </a>
      }
      <div className="dropdown">
        {
          link.sublinks
          ?.filter(link => !link.mobile)
          .map((sublink, index) => {
            return <NavLink
              to={sublink.url}
              key={index + 100}
            >
              <span>{sublink.name}</span>
              <hr/>
            </NavLink>
          })
        }
      </div>
    </div>
  })

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSidebar(true)
    }, 500)
    return () => clearTimeout(timer)
  }, [])

  return (
    <nav className={`navbar ${(pageScrolled || isShort) ? 'scrolled' : ''} ${showSidebar ? 'show' : ''}`}>
      <SiteGrid>
        <div className="left">
          <div
            className="mobile-btn"
            onClick={() => setShowMobileSidebar(true)}
          >
            <i className="far fa-bars" />
          </div>
          <Link
            to="/"
            className="logo"
          >
            <img src={(pageScrolled || isShort) ? blueLogo : logo} alt="logo" />
            <h4>Aphrodite</h4>
          </Link>
          <Link
            to="/"
            className="logo mobile-logo"
          >
            <img src={blueLogo} alt="logo" />
          </Link>
        </div>
        <div className="right">
          <div className="menu">
            {menuLinksRender}
          </div>
          <AppButton
            label="Make An Appointment"
            url="/make-an-appointment"
            leftIcon="fas fa-calendar-check"
          />
        </div>
      </SiteGrid>
    </nav>
  )
}

